import { LABEL_CATEGORY_TYPES, ORGANIZATION_HIERARCHY } from '../constants/enums'
import { get } from 'lodash'
import React from 'react'
import { mapLabels } from './mapForSelect'


export const getLabel = (l, color, addLabelToFilter, notClickable = false) => {
    return(<div onClick={() => addLabelToFilter(get(l, 'label'))}
                style={{
                    float: 'left',
                    backgroundColor: `${color}`,
                    padding: '3px',
                    margin: '3px 3px 3px 0px',
                    borderRadius: '3px',
                    fontSize: '0.8em',
                    color: '#4e4e4e',
                    fontWeight: '600',
                    cursor: notClickable ? 'cursor' : 'pointer'
                }}>
        {get(l, 'label.name')}
    </div>)
}

export const searchOrganizationLabels = (search, searchLabels, orgId) => {
    const params = { limit: 50 }

    if (search && search.name) {
        params.filter = `or(name ic ${search.name})`
    }

    return searchLabels(LABEL_CATEGORY_TYPES.ORGANIZATION.id, params, orgId)
        .then(obj => obj.body)
        .then(obj => mapLabels(obj))
}

export const searchOrganizationPersonLabels = (search, searchLabels, intl, orgId) => {
  const params = { limit: 50 }

  if (search && search.name) {
    params.filter = `or(name ic ${search.name})`
  }

  return searchLabels(LABEL_CATEGORY_TYPES.PERSON.id, params, orgId)
    .then(obj => obj.body)
    .then(obj => mapLabels(obj, false, true, intl))
}

export const searchOrganizationAwardLabels = (search, searchLabels, intl, orgId) => {

  const params = { limit: 50 }

  if (search && search.name) {
    params.filter = `or(name ic ${search.name})`
  }

  return searchLabels(LABEL_CATEGORY_TYPES.AWARD.id, params, orgId)
    .then(obj => obj.body)
    .then(obj => mapLabels(obj, false, true, intl))
}




export const getLabels = (labels, addLabelToFilter, notClickable = false, activeOrganization = {}) => {
    const labelsCompList = []

    const isNao = get(activeOrganization, 'hierarchyLevelType.value') === ORGANIZATION_HIERARCHY.NAO.value
    notClickable = isNao ? false : notClickable

    labels && labels.forEach(l => {
        const naoColor = 'rgb(193, 230, 141)'

        const auColor = 'rgb(249, 226, 191)'

        switch (get(l, 'label.organization.hierarchyLevel.value')) {
            case ORGANIZATION_HIERARCHY.NAO.value:
                labelsCompList.push(getLabel(l, naoColor, addLabelToFilter, isNao ? isNao : notClickable))
                break
            case ORGANIZATION_HIERARCHY.RO.value:
                labelsCompList.push(getLabel(l, naoColor, addLabelToFilter, notClickable))
                break
            case ORGANIZATION_HIERARCHY.SOA.value:
                labelsCompList.push(getLabel(l, naoColor, addLabelToFilter, notClickable))
                break
            case ORGANIZATION_HIERARCHY.OA.value:
                labelsCompList.push(getLabel(l, naoColor, addLabelToFilter, notClickable))
                break
            case ORGANIZATION_HIERARCHY.IC.value:
                labelsCompList.push(getLabel(l, naoColor, addLabelToFilter, notClickable))
                break
            case ORGANIZATION_HIERARCHY.AU.value:
                labelsCompList.push(getLabel(l, auColor, addLabelToFilter, notClickable))
                break
            case ORGANIZATION_HIERARCHY.IAC.value:
                labelsCompList.push(getLabel(l, auColor, addLabelToFilter, notClickable))
                break
            default: break
        }
    })

    return labelsCompList
}


export const getGridLabels = (gridLabels, addLabelToFilter, notClickable = false, activeOrganization = {}) => {
  const labels = (gridLabels || [])
    .map(gridLabel => {
      return {
        id: gridLabel.id,
        label: {
          id: gridLabel.id,
          name: gridLabel.name,
          description: gridLabel.description,
          category: {
            value: get(gridLabel, 'category.type')
          },
          organization: {
            hierarchyLevel: {
              value: get(gridLabel, 'organization.hierarchyLevel.type')
            }
          }
        }
      }
    })

  return getLabels(labels, addLabelToFilter, notClickable, activeOrganization)
}
